import { useGameState } from '../net/GameProvider.js';
import { Big2GameScreen } from './game/big2/Big2GameScreen.js';
import { MuushigGameScreen } from './game/muushig/MuushigGameScreen.js';
import { TwentyOneGameScreen } from './game/twentyone/TwentyOneGameScreen.js';
import { DaaluuGameScreen } from './game/daaluu/DaaluuGameScreen.js';

export function GameScreen({ onOpenProfile }: { onOpenProfile?: () => void }) {
  const { state } = useGameState();
  const { game } = state;

  if (!game) return null;
  if (game.gameType === 'daaluu') return <DaaluuGameScreen onOpenProfile={onOpenProfile} />;

  if (game.gameType === 'twentyone') {
    return <TwentyOneGameScreen onOpenProfile={onOpenProfile} />;
  }

  if (game.gameType === 'muushig') {
    return <MuushigGameScreen onOpenProfile={onOpenProfile} />;
  }

  return <Big2GameScreen onOpenProfile={onOpenProfile} />;
}
